import {MenuItem, Select} from "@mui/material";
import {FormattedMessage, defineMessages} from "react-intl";
import {FaxDirection} from "@/api";

type Props = {
    direction: FaxDirection;
    setDirection: (d: FaxDirection) => void;
    disabled: boolean;
};

const FAX_DIRECTION_FILTER_MESSAGES = defineMessages<FaxDirection>({
    ALL: {id: "faxRecordsList.filters.direction.all", defaultMessage: "All"},
    INCOMING: {id: "faxRecordsList.filters.direction.incoming", defaultMessage: "Incoming"},
    OUTGOING: {id: "faxRecordsList.filters.direction.outgoing", defaultMessage: "Outgoing"},
});

export const DirectionWidget = ({direction, setDirection, disabled}: Props) => {
    return (
        <div style={{display: "flex", alignItems: "center"}}>
            <Select
                value={direction}
                margin="dense"
                variant="outlined"
                onChange={(ev) => setDirection(ev.target.value as FaxDirection)}
                disabled={disabled}
            >
                <MenuItem key={"all"} value={FaxDirection.All}>
                    <FormattedMessage {...FAX_DIRECTION_FILTER_MESSAGES[FaxDirection.All]} />
                </MenuItem>
                <MenuItem key={"incoming"} value={FaxDirection.Incoming}>
                    <FormattedMessage {...FAX_DIRECTION_FILTER_MESSAGES[FaxDirection.Incoming]} />
                </MenuItem>
                <MenuItem key={"outgoing"} value={FaxDirection.Outgoing}>
                    <FormattedMessage {...FAX_DIRECTION_FILTER_MESSAGES[FaxDirection.Outgoing]} />
                </MenuItem>
            </Select>
        </div>
    );
};
